import { css } from '@/styled-system/css';

/**
 * Progressive Enhancement Content Styles
 *
 * The readMoreContent class implements progressive enhancement:
 * 1. Default: All content visible (SEO/no-JS friendly)
 * 2. Enhanced: Truncation applied only after JavaScript loads
 * 3. Expanded: Truncation removed when user clicks "read more"
 */
export const readMoreContent = css({
  fontSize: 'md', // 16px
  lineHeight: '1.5',
  color: 'hpxBlue500', // Body text color
  margin: 0,
  whiteSpace: 'pre-line',
  // Default: Display all content (progressive enhancement baseline)
  display: 'block',

  // Enhanced: Apply truncation only when JavaScript sets data attribute
  '&[data-js-enhanced="true"]:not([data-expanded="true"])': {
    display: '-webkit-box',
    WebkitLineClamp: 'var(--line-clamp, 2)',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  } as any, // Type assertion for vendor prefixes

  // Expanded: Remove truncation when user expands content
  '&[data-expanded="true"]': {
    display: 'block',
    WebkitLineClamp: 'unset',
  },
});

/**
 * SEO-Friendly Content Styles (Constellation V10 Pattern)
 *
 * Follows Constellation's ShowHide pattern: all content in HTML DOM,
 * but portions are visually hidden until user interaction.
 */
export const seoContentContainer = css({
  fontSize: 'md', // 16px
  lineHeight: '1.5',
  color: 'hpxBlue500', // Body text color
  margin: 0,
  whiteSpace: 'pre-line',
});

export const visibleContent = css({
  display: 'inline', // Always visible
});

// Note: hiddenContent styles now handled inline in component for better reliability

export const readMoreButton = css({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 'xs', // 4px between text and icon
  background: 'none',
  border: 'none',
  padding: 0,
  fontSize: 'tiny', // 12px
  fontWeight: '700',
  color: 'hpxTeal500',
  cursor: 'pointer',
  marginTop: 'xs', // 4px margin from descriptive text

  _hover: {
    opacity: 0.8,
  },

  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
    borderRadius: '2px',
  },

  _disabled: {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
});

export const caretIcon = css({
  width: '16px',
  height: '16px',
  transitionProperty: 'transform',
  transitionDuration: '0.2s',
  transitionTimingFunction: 'ease',
  flexShrink: 0,
});

export const caretIconRotated = css({
  transform: 'rotate(180deg)',
});
